/*
 * Copyright (c) 2021. Dave van Rijn Development
 */

import Cookies, {CookieAttributes} from "js-cookie";
import {debug, getSetting} from "./miscUtil";

let jwtToken: string | null = null;

export const getJwt = (): string | null => {
    if (jwtToken && jwtToken.length) return jwtToken;

    const jwt = getJwtFromStorage();
    if (jwt && jwt.length) return jwt;

    const cookieJwt = Cookies.get('JWT');
    if (cookieJwt && cookieJwt.length)
        return cookieJwt;
    return null;
};

export const setJwt = (token: string | null, preserveOnNull: boolean = false, includeStorage: boolean = true) => {
    jwtToken = token;
    if (window.allowCookies || !token) {
        if (token) {
            let options: CookieAttributes = {expires: 1, sameSite: 'strict'};
            if (getSetting('mode') !== 'dev') {
                options.secure = true;
                options.sameSite = 'strict';
            }
            Cookies.set('JWT', token, options);
        } else if (!preserveOnNull) removeJwtCookie();
        if (includeStorage)
            setJwtToStorage(token, preserveOnNull);
    }
};

const setJwtToStorage = (token: string | null, preserveOnNull: boolean = false) => {
    if ((token === null || token === undefined) && !preserveOnNull) removeJwtFromStorage();
    else if (token !== null && token !== undefined) {
        try {
            if (window.localStorage)
                window.localStorage.setItem('JWT', JSON.stringify(token));
        } catch {
            // Localstorage not supported
        }
    }
};

const removeJwtFromStorage = () => {
    try {
        if (window.localStorage)
            window.localStorage.removeItem('JWT');
    } catch {
        // Localstorage not supported
    }
};

const removeJwtCookie = () => {
    Cookies.remove('JWT');
};

const getJwtFromStorage = (): string | null => {
    try {
        if (window.localStorage) {
            const item: string | null = window.localStorage.getItem('JWT');
            if (item === null) return null;
            return JSON.parse(item);
        }
    } catch {}
    return null;
};